// opervex-frontend/src/routes/commonRoutes.js
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import Home from "../pages/Home";
import Dashboard from "../pages/Dashboard";
import TenantRedirect from "./tenantRedirect";

const commonRoutes = [
  { path: "", private: true, component: <Home /> },
  { path: "Login", private: false, component: <Login />, addWithoutTenantId: true },
  { path: "Logout", private: false, component: <Logout />, addWithoutTenantId: true },
  { path: "Dashboard", private: true, component: <Dashboard /> },
  { path: "/:tenantId/*", private: true, component: <TenantRedirect /> },
  { path: "*", private: true, component: <Login />, addWithoutTenantId: true },
];

export default commonRoutes;

// {/* Redirecionamento opcional */}
// <Route path="/:tenantId/*" element={<TenantRedirect />} />
// <Route path="*" element={<Navigate to="/Login" />} />
